import React, { useState, useEffect } from "react";

export default function FilterBar({ listings, onFilter }) {
    const [search, setSearch] = useState("");
    const [province, setProvince] = useState("");
    const [category, setCategory] = useState("");
    const [rating, setRating] = useState("");
    const [sortBy, setSortBy] = useState("");

    let filtered = listings || [];
    const provinceOptions = [...new Set((listings || []).map(biz => biz.province).filter(Boolean))];
    // options: keep using catagory
    const categoryOptions = [
        ...new Set((listings || [])
            .map(biz => biz.catagory)      // ✅ correct key
            .filter(Boolean))
    ];

    const ratingOptions = [...new Set((listings || []).map(biz => Math.floor(biz.rating || 0)))].sort((a, b) => b - a);

    const [debouncedSearch, setDebouncedSearch] = useState(search);

    // 🔥 Debounce search
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(search), 150);
        return () => clearTimeout(timer);
    }, [search]);

    // 🔥 APPLY FILTERS AUTOMATICALLY WHEN ANY FILTER CHANGES
    useEffect(() => {
        let filtered = listings || [];

        if (debouncedSearch)
            filtered = filtered.filter(biz =>
                biz.title?.toLowerCase().includes(debouncedSearch.toLowerCase())
            );

        if (province)
            filtered = filtered.filter(biz => biz.province === province);

        // filter: also use catagory here
        if (category)
            filtered = filtered.filter(biz => biz.catagory === category);  // ✅ use catagory


        if (rating)
            filtered = filtered.filter(biz => Math.floor(biz.rating) >= parseInt(rating));

        if (sortBy === "newest")
            filtered = [...filtered].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        if (sortBy === "top-rated")
            filtered = [...filtered].sort((a, b) => b.rating - a.rating);

        if (typeof onFilter === "function") {
            onFilter(filtered);
        }
    }, [debouncedSearch, province, category, rating, sortBy, listings]);

    // RESET BUTTON
    const resetFilters = () => {
        setSearch("");
        setProvince("");
        setCategory("");
        setRating("");
        setSortBy("");
        onFilter(listings);
    };

    // Styles (same as yours)
    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            padding: "10px 14px",
            backgroundColor: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",

            /* ✅ ONLY STICKY */
            position: "sticky",
            top: "90px",          // match navbar height
            zIndex: 1020,         // below navbar (Bootstrap navbar is 1030)
            background: "#fff",
            marginBottom: "16px"
        },


        input: {
            flex: 1,
            minWidth: "180px",
            padding: "7px 10px",

            /* 🔥 Match container */
            borderRadius: "6px",

            border: "1px solid #d1d5db",
            fontSize: "14px",
            outline: "none",
            boxShadow: "none"
        },

        select: {
            minWidth: "140px",
            padding: "7px 10px",

            /* 🔥 Match container */
            borderRadius: "6px",

            border: "1px solid #d1d5db",
            fontSize: "14px",
            backgroundColor: "#fff",
            outline: "none",
            boxShadow: "none"
        },

        buttonSecondary: {
            padding: "7px 16px",

            /* 🔥 Not pill, corporate */
            borderRadius: "6px",

            fontSize: "14px",
            cursor: "pointer",
            border: "1px solid #d1d5db",
            backgroundColor: "#f9fafb",
            color: "#333",
            fontWeight: 500
        }

    };

    useEffect(() => {
        const el = document.getElementById("filter-bar");

        const onScroll = () => {
            if (window.scrollY > 120) {
                el.style.boxShadow = "0 6px 18px rgba(0,0,0,0.12)";
            } else {
                el.style.boxShadow = "none";
            }
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);


    return (
        <div id="filter-bar" style={styles.container}>
            <input
                type="text"
                style={styles.input}
                placeholder="Search by title..."
                value={search}
                onChange={e => setSearch(e.target.value)}
            />

            <select style={styles.select} value={province} onChange={e => setProvince(e.target.value)}>
                <option value="">All Provinces</option>
                {provinceOptions.map((p, i) => <option key={i}>{p}</option>)}
            </select>

            <select
                style={styles.select}
                value={category}
                onChange={e => setCategory(e.target.value)}
            >
                <option value="">All Categories</option>
                {categoryOptions.map((c, i) => (
                    <option key={i} value={c}>{c}</option>
                ))}
            </select>


            <select style={styles.select} value={rating} onChange={e => setRating(e.target.value)}>
                <option value="">Any Rating</option>
                {ratingOptions.map((r, i) => (
                    <option key={i}>{`${"★".repeat(r)} & Up`}</option>
                ))}
            </select>

            <select style={styles.select} value={sortBy} onChange={e => setSortBy(e.target.value)}>
                <option value="">Sort By</option>
                <option value="newest">Newest</option>
                <option value="top-rated">Top Rated</option>
            </select>

            {/* ❌ Removed APPLY button */}

            <button style={styles.buttonSecondary} onClick={resetFilters}>Reset</button>
        </div>
    );
}
